var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M56.2,47C58,43.6,59,39.8,59,36c0-12.7-10.3-23-23-23S13,23.3,13,36c0,3.7,0.9,7.4,2.7,10.7 c0,0.1,0,0.1,0.1,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m29.6 58.1c2.1 0.6 4.2 0.9 6.4 0.9 2.1 0 4.2-0.3 6.2-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m45.8 45.2c-5.7 4.7-13.9 4.7-19.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m31.7 33.4c-1-2.4-3.8-3.5-6.2-2.4-1.1 0.5-1.9 1.3-2.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m48.9 33.4c-1-2.4-3.8-3.5-6.2-2.4-1.1 0.5-1.9 1.3-2.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m28.3 61.7c-0.8965-0.7643-1.554-1.366-1.8-2.4-0.2426-2.983-1.549-5.769-2.8-8.1-0.3-0.5-0.9-2-1.5-2.2-0.9-0.3-1.5 0-1.7 1.1s0.6 3.3 0.8 3.9c-2.357-1.253-4.571-2.707-6.4-4.1-1.2-0.7-2.2-0.4-2.7 0.4-0.2 0.3-0.2 0.5-0.3 0.7-1.5-1.1-2.6-0.7-3.1 0-0.5 0.6-0.5 1.5-0.1 2.1-0.2 0.1-0.4 0.3-0.5 0.5-0.6 1-0.3 2.3 0.7 2.9 0.2 0.1 0.5 0.4 0.9 0.6-0.1 0.1-0.2 0.1-0.2 0.2-0.5 0.6-0.5 1.6 0 2.2 1.6 2.8 9 4.9 11.5 5.5l1.8 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m48.6 66.8 1.8-1.8c2.5-0.6 9.9-2.8 11.5-5.5 0.5-0.6 0.5-1.6-0.1-2.1-0.1-0.1-0.1-0.2-0.2-0.2 0.5-0.3 0.8-0.6 0.9-0.6 1-0.6 1.3-1.9 0.7-2.9-0.1-0.2-0.3-0.4-0.5-0.5 0.4-0.6 0.4-1.5-0.1-2.1s-1.6-1.1-3.1 0c0-0.3-0.1-0.6-0.3-0.7-0.5-0.7-1.4-1.1-2.7-0.4 0 0-0.1 0-0.1 0.1-1.9 1.6-4.1 2.9-6.3 4 0.5026-1.286 1.69-5.814-0.6-5.1-0.6 0.2-1.2 1.7-1.5 2.2-1.738 2.511-2.258 5.218-2.8 8.1 0.03102 1.077-1.076 1.676-1.8 2.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProud);
export default __webpack_public_path__ + "static/media/Proud.d7d8a90d34375e4b3d71eb9336b87e58.svg";
export { ForwardRef as ReactComponent };